import React, { memo } from 'react';
import Thumbnail from '@components/@core/Thumbnail';
import cx from 'classnames';
import EditDropdown from '@components/EditDropdown';
import { LibraryTrackMenu } from '~/services/config';
import { removeAssign } from '~/services/util';

const Track = ({ userRole, name, modules, courses, assigned, thumbnail, description, published, trackCount, onSelect, onToggle }) => {
    const options = removeAssign(LibraryTrackMenu[userRole], published);
    return (
        <div className="library-track-card px-0">
            <div className="lib-content">
                <div className="d-flex d-flex-1 w-90">
                    <Thumbnail source={thumbnail} />
                    <div className="track-content">
                        <div className="d-flex-5 cursor-pointer" onClick={onToggle}>
                            <p className="body-4 pb-0 mb-1 text-truncate word-break text-wrap-ssm">{name}</p>
                            <p className="dsl-b16 text-truncate word-break mb-0">{description}</p>
                        </div>
                        <div className="d-flex-1">
                            <p className="dsl-b16 ms-2 mb-0 text-nowrap count">{courses || 0}</p>
                        </div>
                        <div className="d-flex-1">
                            <p className="dsl-b16 ms-3 mb-0 text-nowrap count">{modules || 0}</p>
                        </div>
                        <div className="d-flex-1">
                            <p className="dsl-b16 ms-4 mb-0 text-nowrap count">{assigned || 0}</p>
                        </div>
                    </div>
                </div>
                <div className={cx('edit p-0', trackCount > 4 && 'editDropdownScroll')}>
                    <EditDropdown options={options} onChange={onSelect} />
                </div>
            </div>
        </div>
    );
};

export default memo(Track);
